export default {"src":"/_next/static/media/VLY.d2ac9f8d.svg","height":18,"width":18};